import React from "react";

function ListItem({ session, onClick, isSelected }) {
  return (
    <button
      onClick={onClick}
      className={`btn rounded-0 btn-sm ${isSelected ? "btn-dark" : "btn-outline-dark"}`}
      style={{ width: "250px" }}
    >
      <b>{session.location}</b><br/><i>{session.title}</i>
    </button>
  );
}

export default ListItem;